import {createApp} from 'vue'
import App from './App.vue'
import i18n from '../../i18n'
import pinia from '../../pinia'
import router from '../../router'
import floatingvue from 'floating-vue'
import '../../assets/css/index.css'
import {floatingVueOptions, floatingVueTooltipDirectives} from '../../custom-floating-vue'
import {autoAnimatePlugin} from '@formkit/auto-animate/vue'

import * as Sentry from '@sentry/vue'
import {CaptureConsole} from '@sentry/integrations'
import {VueQueryPlugin} from '@tanstack/vue-query'
import {setupGtm} from './gtm'
import {getEnvironment} from '../../utils/getEnvironment'
import {interceptorsSetup} from '../../axios'
import {version as currentVersion} from '../../../package.json'
import '../../vee-validate-rules'
import '../../yup'

/** @type {import('@tanstack/vue-query').VueQueryPluginOptions} */
const vueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
      },
    },
  },
}

interceptorsSetup()

const app = createApp(App)
app.use(i18n)
app.use(pinia)
app.use(router)

setupGtm(app, router, pinia)
app.use(autoAnimatePlugin)
app.use(floatingvue, floatingVueOptions)
app.use(VueQueryPlugin, vueQueryPluginOptions)
app.directive('tt', floatingVueTooltipDirectives)

async function bootstrap() {
  try {
    let environment = getEnvironment()
    let sessionSampleRate = 0
    let onErrorSampleRate = environment === 'production' ? 0.7 : 0
    Sentry.init({
      app,
      dsn: 'https://15e8dfa6bc64739d23bafe46d18abc94@o4505347070427136.ingest.sentry.io/4505946558038016',
      environment: environment,
      release: currentVersion,
      integrations: [
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
        new Sentry.Replay(),
        new CaptureConsole({
          levels: ['error'],
        }),
      ],
      ignoreErrors: [/rbt\.expired/, /Network Error/, /Request failed with status code 401/],
      tracesSampleRate: 0.7,
      replaysSessionSampleRate: sessionSampleRate,
      replaysOnErrorSampleRate: onErrorSampleRate,
    })
  } finally {
    app.mount('#app')
  }
}

bootstrap()
